import { render, staticRenderFns } from "./SupplierImport.vue?vue&type=template&id=5d5df898&"
import script from "./SupplierImport.vue?vue&type=script&lang=js&"
export * from "./SupplierImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports